exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sectionColor___1jc9i {\n  background-color: #f7f7f7;\n}\n.container___3RRbk {\n  display: flex;\n}\n@media (max-width: 991px) {\n  .container___3RRbk {\n    flex-direction: column;\n  }\n}\n.brandsSection___3sGHV {\n  width: 67%;\n}\n@media (max-width: 991px) {\n  .brandsSection___3sGHV {\n    width: 100%;\n  }\n}\n.addExternalSection___2Frf6 {\n  width: 33%;\n}\n@media (max-width: 991px) {\n  .addExternalSection___2Frf6 {\n    width: 100%;\n  }\n}\n", ""]);

// exports
exports.locals = {
	"sectionColor": "sectionColor___1jc9i",
	"container": "container___3RRbk",
	"brandsSection": "brandsSection___3sGHV",
	"addExternalSection": "addExternalSection___2Frf6"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/components/manage/website/entities/RegistryContainer/RegistryOnboardContainer/components/BrandsSection/BrandsSection.module.less
// module id = 2041
// module chunks = 51